import { useGetTasksApiV1TasksGet } from "../../../vl-api/vlComponents";

export function useDatasetLastUpdated(datasetId: string): string {
  const { data } = useGetTasksApiV1TasksGet({
    queryParams: {
      dataset_id: datasetId,
      task_type: ["MEDIA_ADDITION", "REINDEX"],
      task_status: ["COMPLETED"],
      sort_by: "start_time",
      sort_order: "desc",
    },
  });

  return data?.tasks?.[0]?.end_time;
}
